module.exports = __webpack_public_path__ + "static/media/ic_模板.c082f3f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_模板.svg
// module id = 195
// module chunks = 0